export const constants = {
  REDIRECT_URL: 'REDIRECT_TO_OLD_URL',
  FRESH_SESSION: 'fresh_session',
  TOKEN_FIELD: 'jwtToken',
  AUTHENTICATION_FIELD: 'AuthState',
}

export const errorTypes = {
  BAD_REQUEST: 'BAD_REQUEST',
  SERVER: 'SERVER',
}

export const URLS = {
  GET_ALLOWED_SHOWING_PROVIDERS: '/getallowedshowingproviders',
  SAVE_DEFAULT_SHOWING_PROVIDER: '/savedefaultshowingprovider',
  GET_SHOWING_PROVIDER_LINK: '/showingproviderlink',
}

export const PROVIDER_NONE = '00000000-0000-0000-0000-000000000000'
export const PROVIDER_SHOWINGTIME = '11111111-1111-1111-1111-111111111111'

export const FEATURE_FLAGS = {
  SHOWING_CHOICE: 'showing_choice',
}
